
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { NextPage } from 'next';
import { NextSeo } from 'next-seo';
import useTranslation from 'next-translate/useTranslation';
import { useEffect } from 'react';
import BuyerProfileLayout from '../../components/BuyerProfile/BuyerProfileLayout';
import CustomerProvider from '../../components/BuyerProfile/Account/CustomerProvider';
import MyCatalogs from '../../components/BuyerProfile/Catalogs/MyCatalogs';
import { getSEOProps } from '../../next-seo.config';
import useBuyerCatalogs from '../../services/useBuyerCatalogs';
import useOthersYouMayLike from '../../services/recommendationsAPI/useOthersYouMayLike';
import ProductCarousel from '../../components/Carousels/ProductCarousel';
import { AnalyticsProductCarouselTypes } from '../../utils/types/analytics';
import styles from '../../styles/BuyerPortalPage.module.less';
const CatalogListPage: NextPage = () => {
    const { t } = useTranslation('buyerProfile');
    const { allCatalogSkus } = useBuyerCatalogs();
    const { data: similarItems, triggerDetailPageView, } = useOthersYouMayLike({ associatedItems: allCatalogSkus });
    useEffect(() => {
        if (allCatalogSkus.length > 0) {
            // Load similar items recommendations
            triggerDetailPageView(allCatalogSkus);
        }
    }, [allCatalogSkus.length]);
    return (<>
      <NextSeo {...getSEOProps()({
        title: t('My catalogs'),
    })}/>
      <BuyerProfileLayout showProfileMobileLayout={false} mobileHeader={(<h2 className="margin-bottom-spacer-double">
            {t('My catalogs')}
          </h2>)}>
        <CustomerProvider>
          <MyCatalogs />
        </CustomerProvider>
      </BuyerProfileLayout>

      <div className={styles['buyer-portal-carousel-wrapper']}>
        <ProductCarousel carouselType={AnalyticsProductCarouselTypes.SimilarItems} productCardType="narrow" products={similarItems} title={t('products:Other products you may like')} hasCardBorder/>
      </div>
    </>);
};
export default CatalogListPage;

    async function __Next_Translate__getStaticProps__197eaaccb7e__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/my-catalogs/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__197eaaccb7e__ as getStaticProps }
  